import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { Translate } from 'react-redux-i18n';
import {
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_SUCCESS,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED,
} from 'constants/nonuser-charge';

const COLOR_MAP = {
    [NONUSER_CHARGE_STATUS_UNPAID]: 'warning',
    [NONUSER_CHARGE_STATUS_FAILED]: 'danger',
    [NONUSER_CHARGE_STATUS_SUCCESS]: 'success',
    [NONUSER_CHARGE_STATUS_REVOKED]: 'dark',
};

const NonUserChargeStatus = ({ type, className, badge }) => {
    let el;
    let color = 'dark';

    switch (type) {
    case NONUSER_CHARGE_STATUS_UNPAID:
    case NONUSER_CHARGE_STATUS_FAILED:
    case NONUSER_CHARGE_STATUS_SUCCESS:
    case NONUSER_CHARGE_STATUS_REVOKED:
        el = <Translate value={ `nonuser_charge.nonuser_charge_status_map.${ type }` } />;
        color = COLOR_MAP[type];
        break;
    default:
        el = <span>--</span>;
    };

    if (badge) {
        el = (
            <Badge color={ color } className={ className }>
                { el }
            </Badge>
        );
    }

    return el;
};
NonUserChargeStatus.propTypes = {
    type: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    className: PropTypes.string,
    badge: PropTypes.bool,
};
NonUserChargeStatus.defaultProps = {
    type: undefined,
    className: undefined,
    badge: false,
};
export default NonUserChargeStatus;
